import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function RulerIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M15.2865 13C16.9582 11.7283 18 9.95776 18 8C18 4.14062 13.9629 1 9 1C4.03711 1 0 4.14062 0 8V14C0 19.0098 3.77832 22 10.1065 22H22V23.4609H24V13H15.2865ZM9 3C12.8594 3 16 5.24316 16 8C16 10.7568 12.8594 13 9 13C5.14062 13 2 10.7568 2 8C2 5.24316 5.14062 3 9 3ZM22 20H18V17H16V20H11V17H9V19.9623C5.98535 19.7628 2 18.6259 2 14V12.39C3.65118 13.9796 6.17389 15 9 15H22V20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M9 10C10.6569 10 12 9.10457 12 8C12 6.89543 10.6569 6 9 6C7.34315 6 6 6.89543 6 8C6 9.10457 7.34315 10 9 10Z",
    fill: "currentColor"
  }));
}